export default __webpack_public_path__ + "static/media/results-tubes-210.9054474f.svg";